import React, { useState } from "react";

interface TabConfig {
  label: string;
  count?: number | null;
}

interface CustomProps {
  changeValue: Function;
  selected: string;
  tabConfig: TabConfig[];
}

const CustomTabs = (props: CustomProps) => {
  const [value, setValue] = useState(
    props.selected === "" ? "Team" : props.selected
  );

  const handleChange = (newValue: string) => {
    props.changeValue(newValue);
    setValue(newValue);
  };

  return (
    <div className="flex flex-wrap gap-2 overflow-x-auto py-1">
      {props.tabConfig.map((tab: TabConfig) => {
        const active = value === tab.label;
        return (
          <button
            key={tab.label}
            type="button"
            onClick={() => handleChange(tab.label)}
            className={`inline-flex items-center gap-2 rounded-yh-md border px-4 py-2 text-sm transition-colors ${
              active
                ? "border-yh-blue bg-yh-blue text-white"
                : "border-yh-border bg-white text-yh-black hover:border-yh-blue hover:bg-yh-lilac"
            }`}
          >
            <span className="font-medium">{tab.label}</span>
            {tab.count != null && (
              <span
                className={`rounded-full px-2 py-0.5 text-xs ${
                  active ? "bg-white/20 text-yh-green" : "bg-yh-lilac text-yh-blue"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default CustomTabs;
